import { Injectable } from '@angular/core';
import { Router, CanLoad } from '@angular/router';
import { take, map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { SessionService } from '@app-store/session/session.service';
import { isAdminUser } from '@app-store/session/session.query';
import { ToastrService } from 'ngx-toastr';

/**
 * Restringe a área privada (admin) a usuários com role ADMIN.
 * Busca o usuário atual em /users/me (que inclui as roles) e bloqueia quem não
 * for ADMIN, deslogando e voltando para o login.
 */
@Injectable({
	providedIn: 'root'
})
export class AdminGuard implements CanLoad {
	constructor(
		private router: Router,
		private sessionService: SessionService,
		private toastr: ToastrService
	) {}

	canLoad(): Observable<boolean> {
		return this.sessionService.getUserFromBack().pipe(
			take(1),
			map(userInfo => {
				const isAdmin = isAdminUser(userInfo);
				if (!isAdmin) {
					this.toastr.error('Acesso restrito a administradores.');
					this.sessionService.logout();
				}
				return isAdmin;
			}),
			catchError(() => {
				this.router.navigateByUrl('/login');
				return of(false);
			})
		);
	}
}
